import Vue from 'vue'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const headerHost = (data) => {
  const host = data?.host?.name

  if (!host) return ''

  return `
    <div class="d-block mt-3">
      <h6 class="text-uppercase grey--text mt-2">
        ${translate(area + 'host')}
      </h6>
      <span class="body-2">
        ${host}
      </span>
    </div>
  `
}

export default headerHost
